import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import styles from './index.module.scss';
interface ReplyTimeProps {
  text: string;
}
export const ReplyTime = t0 => {
  const $ = _c(3);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames("caption small book", styles["reply-time-text"]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <p className={t1}>{text}</p>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};